module.exports = "<div class=\"evtBiblRef\" compile=\"vm.getFormattedBibl()\">\r\n</div>\r\n";